declare var window: any
export default class Utils {
    public static alertConfiguration = {
        timeOut: 5000,
        showProgressBar: false,
        pauseOnHover: false,
        clickToClose: true,
    }

    public static convertToCamelcase(str: string): string {
        return str.replace(/_([a-z])/g, (all, char) => char.toUpperCase())
    }

    public static capitalizeWords(str: string) {
        return str.replace(/\b\w/g, function (char) {
            return char.toUpperCase()
        })
    }

    public static shareLinkToGC() {
        const resourceUrlToShareGoogleClass =
            "https://classroom.google.com/share?url=" + window.location
        const googleClassWindow = window.open(
            "",
            "_blank",
            "width=640, height=450,toolbar=no, scrollbars=yes"
        )
        googleClassWindow.location.href = resourceUrlToShareGoogleClass
    }

    public static removeHtmlTags(text: string = "") {
        return String(text)
            .replace(/<!--[\s\S]*?(?=-->)-->/gm, "") // Remove comments
            .replace(/<[^>]+>/gm, "")
            .replace(/(\r\n|\n|\r)/gm, "")
    }

    public static escapePosterImage(posterImage: any) {
        if (this.isArray(posterImage)) {
            return posterImage.map((item) => {
                item.url = Utils.escapePosterImage(item.url)
                return item
            })
        }
        if (this.isString(posterImage)) {
            return this.urlEscapeQuotes(posterImage)
        }
        if (posterImage && posterImage.url) {
            posterImage.url = this.urlEscapeQuotes(posterImage.url)
        }
        return posterImage
    }

    public static urlEscapeQuotes(url: string) {
        if (url) {
            return url.replace(/'/g, "\\'")
        }
        return null
    }

    public static isArray(arr: any) {
        return Object.prototype.toString.call(arr) === "[object Array]"
    }

    public static isObject(obj: any) {
        return Object.prototype.toString.call(obj) === "[object Object]"
    }

    public static isString(str: string) {
        return Object.prototype.toString.call(str) === "[object String]"
    }

    public static isEmpty(value: any): boolean {
        if (typeof value === "number") return false
        else if (typeof value === "string") return value.trim().length === 0
        else if (Array.isArray(value)) return value.length === 0
        else if (typeof value === "object") return value == null || Object.keys(value).length === 0
        else if (typeof value === "boolean") return false
        else return !value
    }

    public static isNullOrUndefined(value: any): boolean {
        return value == null
    }

    public static copyLinkByElementId(elemId) {
        const elem = document.getElementById(elemId) as HTMLInputElement
        elem.select()
        document.execCommand("copy")
    }

    public static removeStyling(htmlString) {
        if (htmlString) {
            // remove all styles from the html received as string (for example fields with TinyMCE widgets)
            htmlString = htmlString.replace(/[^ <>]*style="[^<>]*"/gm, "")
            // a whitelist of allowed tags
            const whitelist = [
                "ul",
                "ol",
                "li",
                "sub",
                "sup",
                "table",
                "tbody",
                "tr",
                "td",
                "p",
                "span",
            ]
            const regex = new RegExp("</?(?!" + whitelist.join("|") + ")[^>/]+>", "gm")
            return htmlString !== null ? htmlString.replace(regex, "") : ""
        }
        return htmlString
    }

    public static getCurrentYear() {
        return new Date().getFullYear()
    }

    public static isAssignmentCode(code) {
        if (!code) {
            return false
        }
        const firstCharacter = code[0]
        return firstCharacter >= "a" && firstCharacter <= "z"
    }

    public static getITSImageIfExists(
        images: any[],
        type: string,
        width?: number,
        height?: number
    ) {
        if (!images) {
            return null
        }
        const posterImage = images.find((image) => image.type === type)
        if (!posterImage) {
            return null
        }
        if (width && height && (type === "original" || type === "original-square")) {
            return `${posterImage.url}?resize=${width}x${height}&format=${
                Utils.shouldNotUseWebp() ? "jpg" : "webp"
            }`
        }
        return posterImage.url
    }

    public static openInNewTab(url: string) {
        const win = window.open(url, "_blank", "noopener")
        if (win) {
            win.focus()
        }
    }

    public static generateUniqueId(): string {
        return (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase()
    }

    public static copyTextToClipboard(text: string) {
        const selBox = document.createElement("textarea")
        selBox.style.position = "fixed"
        selBox.style.left = "0"
        selBox.style.top = "0"
        selBox.style.opacity = "0"
        selBox.value = text
        document.body.appendChild(selBox)

        // Determine if user's device is an iPad or an iPhone
        if (navigator.userAgent.match(/iPad|iPhone/i)) {
            const range = document.createRange()
            range.selectNodeContents(selBox)
            const selection = window.getSelection()
            selection.removeAllRanges()
            selection.addRange(range)
            selBox.setSelectionRange(0, 999999)
        } else {
            selBox.focus()
            selBox.select()
        }

        document.execCommand("copy")
        document.body.removeChild(selBox)
    }

    public static buildCssSelector(text: string): string {
        return text
            .toLowerCase()
            .match(/[^_\W]+/g)
            .join("-")
    }

    public static resize(callback: any, time: number = 500): void {
        let resizeId
        window.addEventListener("resize", () => {
            clearTimeout(resizeId)
            resizeId = setTimeout(callback, time)
        })
    }

    // Info: The measurement unit is pixel (px).
    public static isScreenWidthLarger(screenWidth: number): boolean {
        if (window.innerWidth > screenWidth) {
            return true
        }

        return false
    }

    public static isIEBrowser() {
        return window.document.hasOwnProperty("documentMode")
    }

    public static isEdgeBrowser() {
        if (!Utils.isIEBrowser() && window.hasOwnProperty("StyleMedia")) {
            return true
        }
        return false
    }

    public static isSafari() {
        let userAgent = window.navigator.userAgent
        let issafari = /^((?!chrome|android).)*safari/i.test(userAgent)
        return userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || issafari
    }

    public static flattenErrors(errors: Record<string, any>, keyPrefix = null): [string, string][] {
        return Object.entries(errors).reduce((acc, [key, val]) => {
            let fullKey = keyPrefix ? `${keyPrefix} - ${key}` : key
            if (key === "non_field_errors") {
                fullKey = "Error"
            }
            val.forEach((err) => {
                if (typeof err === "string") {
                    acc.push([this.capitalizeWords(fullKey.replace("_", " ")), err])
                } else {
                    acc = [...acc, ...Utils.flattenErrors(err, fullKey)]
                }
            })
            return acc
        }, [])
    }

    public static concatenateFlattenErrors(errors: Record<string, any>) {
        let message = Utils.flattenErrors(errors)
        let result: string[] = []
        for (let key in message) {
            result.push(message[key][0] + " - " + message[key][1])
        }
        return result
    }

    /**
     * this includes if it's Safari, IE or Edge
     */
    public static shouldNotUseWebp() {
        return window.PBSLM.browser.ie || window.PBSLM.browser.edge || window.PBSLM.browser.safari
    }

    public static sleep = (ms: number) => new Promise((resolve) => setTimeout(() => resolve(), ms))

    public static shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1))
            ;[array[i], array[j]] = [array[j], array[i]]
        }
    }

    public static getCompareFnByKey(key: string) {
        return (a: Object, b: Object) => {
            const normalizedA = a[key].toUpperCase()
            const normalizedB = b[key].toUpperCase()

            if (normalizedA < normalizedB) {
                return -1
            }
            if (normalizedA > normalizedB) {
                return 1
            }

            return 0
        }
    }

    public static scrollIntoView(element: HTMLElement, offset = 0) {
        document.documentElement.scrollTop = element.offsetTop + offset
    }

    /**
     * Get an array with randomized items and positions
     * @param arr
     * @param n
     */
    public static getRandomItems(arr, n) {
        let len = arr.length
        const taken = new Array(len)
        const result = new Array(n)

        if (n > len) throw new RangeError("getRandomSubjects: more subjects taken than available")
        while (n--) {
            const x = Math.floor(Math.random() * len)
            result[n] = arr[x in taken ? taken[x] : x]
            taken[x] = --len in taken ? taken[len] : len
        }
        return result
    }

    public static isCurrentURLForStudents() {
        return (
            window.location.pathname.startsWith("/student/") ||
            window.location.search.includes("student=true")
        )
    }

    /**
     * Returns a boolean representing if a file name has the right extension
     * @param extType - extension to check for ex: png
     * @param validExtensions - list of valid extensions
     */
    public static hasFileValidExtension(extType: string, validExtensions: string[]): boolean {
        if (!extType || !validExtensions.length) return
        return validExtensions.map((ext) => ext.toUpperCase()).indexOf(extType) >= 0
    }
}
